// extracted by mini-css-extract-plugin
module.exports =  {"avatars":"_0bc5e8de02--avatars--_MZr4","primary":"_0bc5e8de02--primary--Iw0n2","secondary":"_0bc5e8de02--secondary--LCZvi"};